import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-add-comment",
  templateUrl: "./add-comment.component.html",
  styleUrls: ["./add-comment.component.scss"],
})
export class AddCommentComponent {
  selectedBranch: string = "TestBranch";
  selectedImportance: string = "low";
  comment: string = "";

  constructor(private dialogRef: MatDialogRef<AddCommentComponent>) {}

  onSubmit(): void {
    const payload = {
      branch: this.selectedBranch,
      importance: this.selectedImportance,
      comment: this.comment,
    };
    console.log("تسجيل التعليق:", payload);
    this.dialogRef.close(payload);
  }

  onClose(): void {
    this.dialogRef.close(null);
  }
}
